import { Route } from 'react-router-dom';
import UserEditPage from 'sites/admin/inmobiliario/gestionarUsuarios/UserEditPage';
import UserListPage from 'sites/admin/inmobiliario/gestionarUsuarios/UserListPage';
import renderConditionalComponent from 'utils/renderConditionalComponent';

const RoutesUsuarios = () => {
  return (
    <Route path="/usuarios">
      <Route
        path=""
        element={renderConditionalComponent('Users', UserListPage)}
      />

      <Route
        path=":id"
        element={renderConditionalComponent('Users', UserEditPage)}
      />
    </Route>
  );
};

export default RoutesUsuarios;
